import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiClock, FiCalendar } = FiIcons;

const ClockWidget = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="flex flex-col md:flex-row md:items-center space-y-2 md:space-y-0 md:space-x-6 text-slate-600" aria-label="Current Date and Time">
      <div className="flex items-center space-x-2 bg-white/50 backdrop-blur-sm px-4 py-2 rounded-full border border-white shadow-sm">
        <SafeIcon icon={FiClock} className="text-indigo-600" aria-hidden="true" />
        <time dateTime={time.toISOString()} className="font-mono font-bold text-lg">
          {format(time, 'HH:mm:ss')}
        </time>
      </div>
      <div className="flex items-center space-x-2 bg-white/50 backdrop-blur-sm px-4 py-2 rounded-full border border-white shadow-sm">
        <SafeIcon icon={FiCalendar} className="text-indigo-600" aria-hidden="true" />
        <span className="font-medium">{format(time, 'EEEE, MMMM do')}</span>
      </div>
    </div>
  );
};

export default ClockWidget;